import Modal from "example/scripts/modal";


// WEBPACK FOOTER //
// ./example/scripts/main.js